export default __webpack_public_path__ + "static/plexus-hero-right-957e5c14bc2540315c511610dba77d99.webp";